import { render, staticRenderFns } from "./ikhtisar-view-modal.vue?vue&type=template&id=7856aab4&scoped=true&"
import script from "./ikhtisar-view-modal.vue?vue&type=script&lang=js&"
export * from "./ikhtisar-view-modal.vue?vue&type=script&lang=js&"
import style0 from "./ikhtisar-view-modal.vue?vue&type=style&index=0&id=7856aab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7856aab4",
  null
  
)

export default component.exports